const normalizeMacroText = value => (value || '').trim().toLowerCase();

const normalizeMacroSearch = value =>
  normalizeMacroText(value).replace(/^\*\*/, '').trim();

const macroMatchScore = (macroName, searchTerm) => {
  if (!searchTerm) return 0;
  if (macroName === searchTerm) return 0;
  if (macroName.startsWith(searchTerm)) return 1;
  if (searchTerm.length < 3) return Number.POSITIVE_INFINITY;
  if (macroName.includes(searchTerm)) return 2;
  return Number.POSITIVE_INFINITY;
};

export const filterAndSortMacrosByName = (macros = [], searchKey = '') => {
  const normalizedSearch = normalizeMacroSearch(searchKey);

  return [...macros]
    .map((macro, index) => {
      const normalizedName = normalizeMacroText(macro.name);
      return {
        macro,
        index,
        score: macroMatchScore(normalizedName, normalizedSearch),
      };
    })
    .filter(({ score }) => score !== Number.POSITIVE_INFINITY)
    .sort((left, right) => {
      if (left.score !== right.score) return left.score - right.score;
      return left.index - right.index;
    })
    .map(({ macro }) => macro);
};
